export function parseJson(body: any) {
    let json = null;
    try {
        json = JSON.parse(body);
    } catch(e) {
        json = null;
    }
    return json;
}